import React, { Fragment, useEffect, useRef, useState } from "react";
import "./BusinessUnitPreferences.scss";
import { Checkbox, CircularProgress, TextField } from "@mui/material";
import { Select as AntSelect, Switch, InputNumber, Tooltip } from "antd";
import {
  getEmissionMethodService,
  getEmissionSourceData,
  getEmissionCurrencyService,
} from "../../../services/emissionService";
import { useNavigate } from "react-router-dom";
import PWCascader from "../../common/PWCascader/PWCascader";
import { checkSubscriptionPermission, isMultiSources } from "../../../helper";
import { CaretDownOutlined } from "@ant-design/icons";
import { CATEGORY_CODE, STEPS } from "../../../constants/enums";
import { useTranslation } from "react-i18next";
import ConfirmApproveDialog from "../../EmissionLog/EmissionApprovalManagement/ConfirmApproveDialog";
import { useSelector } from "react-redux";
import SubscriptionUpgrade from "../../Subscription/SubscriptionUpgrade";
import { getSettingPreferences } from "../../../services/orgService";

const BusinessUnitPreferences = (props: any) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const {
    id,
    setStep,
    selectedId,
    categoryData,
    setCategoryData,
    categoryPreferences,
    initCategoryPreferences,
    defaultCategoryPreferences,
    setCategoryPreferences,
    createOrUpdateBusinessUnit,
    setCurrency,
    currency,
    carbonPrice,
    setCarbonPrice,
    directEmissionApproval,
    setDirectEmissionApproval,
    isLoading,
    gwpVersion,
    setGwpVersion,
  } = props;
  const toggleRef = useRef<any | null>(null);
  const [isSaveEnable, setIsSaveEnable] = useState(false);
  const [enableAllApproved, setEnableAllApproved] = useState(false);
  const [currencies, setCurrencies] = useState<any>([]);
  const { Option } = AntSelect;
  const handleGWPVersionChange = (event: any) => {
    setGwpVersion(event);
  };
  const styles = (theme: any) => ({
    ".MuiOutlinedInput-notchedOutline": {
      border: "1px solid #D7DFE9",
      borderRadius: "8px",
      height: "3rem",
    },
    "&:hover": {
      ".MuiOutlinedInput-notchedOutline": {
        border: "2px solid #59CE90 !important",
      },
    },
  });

  useEffect(() => {
    executeScroll(selectedId);
  }, [selectedId]);
  const plansPermissions = useSelector(
    (state: any) => state.sub.subscriptionPermissions
  );
  const executeScroll = (id: number) => {
    let reqId = id === -1 ? "basicmain" : `emissionSource${id}`;
    let element = document.getElementById(reqId);
    element?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  const handleSwitch = (e: any) => {
    if (e) {
      setDirectEmissionApproval(true);
      id && setEnableAllApproved(true);
    } else {
      setDirectEmissionApproval(false);
    }
  };
  const handleSwitchValue = (type: any) => {
    type === "cancel" && setDirectEmissionApproval(false);
  };
  //on select categories
  const AddOrRemovePreferences = async (
    event: any,
    categoryId: number,
    index: number
  ) => {
    const categoryPreferencesIndex = categoryPreferences.findIndex(
      (eachPreference: any) =>
        eachPreference.category === categoryData[index].id
    );
    if (categoryPreferencesIndex > -1) {
      if (!event.target.checked) {
        categoryPreferences[categoryPreferencesIndex] = {
          ...categoryPreferences[categoryPreferencesIndex],
          subTypes: [],
          emissionFactorSourceName: null,
          methods: [],
          logEmissionAgainst: "",
          usage: null,
        };
      } else {
        categoryPreferences[categoryPreferencesIndex].usage = "fully";
      }
      categoryPreferences[categoryPreferencesIndex].selected =
        event.target.checked;
      setCategoryPreferences([...categoryPreferences]);

      categoryData[index].selected = event.target.checked;
      categoryData[index].usage =
        categoryPreferences[categoryPreferencesIndex].usage;
      setCategoryData([...categoryData]);
    }

    return;
    const catData: any[] = categoryData;
    catData[index].selected = event.target.checked;
    let catIndex = categoryPreferences.findIndex((eachPreference: any) => {
      return eachPreference.category === categoryId;
    });

    if (catIndex > -1) {
      categoryPreferences.splice(catIndex, 1);
      setCategoryPreferences([...categoryPreferences]);
    } else {
      //initCategoryPreferences  - old pref
      let catIndex1 = initCategoryPreferences.findIndex(
        (eachPreference: any) => {
          return eachPreference.category === categoryId;
        }
      );
      let defaultPrefIndex = defaultCategoryPreferences?.findIndex(
        (eachPreference: any) => {
          return eachPreference.category === categoryId;
        }
      );
      // getEmissionSourceData(catData[index].id).then((res: any) => {
      //   let subTypes = res.data;
      //   subTypes.map((each: any) => {
      //     let children = each.children.filter((each: any) => each.name);
      //     if (!children.length) {
      //       delete each.children;
      //     }
      //     return each;
      //   });

      //   console.log("subTypes", subTypes);
      let newPreference: any = {
        category: catData[index].id,
        name: catData[index].code + " - " + catData[index].name,
        subTypes: [], //subTypes
        // emissionFactorSource: null,
        emissionFactorSourceName: null,
        methods: [],
        logEmissionAgainst: "",
        isAdded: true, //to track which categories were touched by user
      };
      if (defaultPrefIndex > -1) {
        let defaultPreference = defaultCategoryPreferences[defaultPrefIndex];
        newPreference = {
          ...newPreference,
          emissionTypeName: defaultPreference.emissionTypeName,
          emissionType: defaultPreference.emissionType,
          emissionSubType: defaultPreference.emissionSubType,
          methods: defaultPreference.methods,
          emissionSources: defaultPreference.emissionSources,
        };
      }

      if (catIndex1 > -1) {
        newPreference.id = initCategoryPreferences[catIndex1].id;
      }
      let preferences = [...categoryPreferences, newPreference];

      preferences.sort((a: any, b: any) => a.category - b.category);
      setCategoryPreferences(preferences);
      // });
    }
  };
  useEffect(() => {
    let res = categoryPreferences.length !== 0;
    res =
      res &&
      categoryPreferences.filter((eachPreference: any) => {
        //unique subTypes
        let sources = eachPreference?.emissionSources
          ?.map((eachSources: any) => eachSources?.subType)
          .filter(
            (value: any, index: number, array: any) =>
              array.indexOf(value) === index
          );

        let methods = eachPreference?.methods
          ?.filter((eachSources: any) => eachSources?.selected)
          ?.map((eachSources: any) => eachSources?.sub_type)
          .filter(
            (value: any, index: number, array: any) =>
              array.indexOf(value) === index
          );
        let bool =
          sources?.every((eachSubType: number) =>
            methods?.includes(eachSubType)
          ) && eachPreference.selected;
        return bool;
      })?.length ===
        categoryPreferences.filter(
          (eachPreference: any) => eachPreference.selected
        ).length;

    res =
      res &&
      categoryPreferences.filter(
        (eachPreference: any) => eachPreference.selected
      ).length &&
      categoryPreferences.filter(
        (eachPreference: any) =>
          eachPreference.selected &&
          eachPreference.emissionSources?.length &&
          eachPreference.methods?.length
      )?.length ===
        categoryPreferences.filter(
          (eachPreference: any) => eachPreference.selected
        ).length;
    setIsSaveEnable(res);
  }, [categoryPreferences]);
  const getInitOptionsFromDefault = (types: any) => {
    let catTypesData = types ? types : [];
    let resMap: any = {};
    catTypesData.forEach((eachType: any) => {
      if (resMap[eachType.type]) {
        resMap[eachType.type].children.push({
          label: eachType.subTypeName,
          value: eachType.subType,
        });
      } else {
        resMap[eachType.type] = {
          label: eachType.typeName,
          value: eachType.type,
          children: [],
        };
        if (eachType.subType) {
          resMap[eachType.type].children.push({
            label: eachType.subTypeName,
            value: eachType.subType,
          });
        }
      }
    });
    return Object.values(resMap);
  };
  const setCategorySourceContent = async (
    event: any,
    categoryId: number,
    index: number
  ) => {
    let preferences = categoryPreferences;
    let catIndex = categoryPreferences.findIndex((eachPreference: any) => {
      return eachPreference.category === categoryId;
    });

    if (catIndex > -1) {
      getEmissionSourceData(categoryId.toString()).then((res: any) => {
        let subTypes = res.data;
        subTypes = subTypes.map((each: any) => {
          let children = each.children.filter((each: any) => each.label);
          if (!children.length) {
            delete each.children;
          }
          return each;
        });
        //label,value type nested array
        preferences[catIndex].subTypes = subTypes;
        setCategoryPreferences([...preferences]);
      });
    }
  };
  // let dropdownContent = [
  //   {
  //     id: 1,
  //     name: "Emission Data",
  //     children: [
  //       {
  //         id: 2,
  //         name: "Scope1",
  //       },
  //       {
  //         id: 3,
  //         name: "Scope2",
  //       },
  //     ],
  //   },
  //   {
  //     id: 4,
  //     name: "CMS",
  //     children: [
  //       {
  //         id: 5,
  //         name: "Footprints",
  //       },
  //     ],
  //   },
  //   {
  //     id: 6,
  //     name: "GHG",
  //     children: [
  //       {
  //         id: 7,
  //         name: "Carbon Gases",
  //       },
  //     ],
  //   },
  // ];
  const onSelectEmissionSource = (e: any[], index: number) => {
    if (e?.length) {
      let reqObj: any = {};
      reqObj.types = e
        .map((eachType: any) =>
          eachType.subType
            ? eachType.type + "-" + eachType.subType
            : eachType.type
        )
        .toString();
      reqObj.category = categoryPreferences[index].category;
      reqObj.showSubSection = isMultiSources(categoryPreferences[index]);
      getEmissionMethodService(reqObj).then((res) => {
        let data = res.data;
        let preferences = categoryPreferences;
        //type, subtye based array from event e
        preferences[index].emissionSources = e;
        preferences[index].isAdded = true;
        preferences[index].methods = data.map(
          (eachSource: any, index: number) => {
            index === 0
              ? (eachSource.selected = true)
              : (eachSource.selected = false);
            return eachSource;
          }
        );
        setCategoryPreferences([...categoryPreferences]);
      });
    } else {
      let preferences = categoryPreferences;
      //type, subtye based array from event e
      preferences[index].emissionSources = [];
      preferences[index].isAdded = true;
      preferences[index].methods = [];
      setCategoryPreferences([...categoryPreferences]);
    }
  };
  const groupMethodsByTypeSubType = (methods: any[]) => {
    if (methods.length) {
    }
    let val = !methods.length
      ? []
      : Object.entries(
          methods.reduce((accValue, currValue) => {
            accValue[currValue.type + "-" + currValue.sub_type] =
              accValue[currValue.type + "-" + currValue.sub_type] || [];
            accValue[currValue.type + "-" + currValue.sub_type].push(currValue);
            return accValue;
          }, Object.create(null))
        );
    return val;
  };
  const onSelectEmissionLogMethod = (
    e: any,
    categoryIndex: number,
    methodId: number,
    type?: number,
    sub_type?: number
  ) => {
    // const methodIndex = e.target.value;
    let preferences = categoryPreferences;

    let logEmissionMethods = preferences[categoryIndex].methods;
    const methodIndex = logEmissionMethods.findIndex(
      (eachMethod: any) =>
        eachMethod.id === methodId &&
        (!sub_type || sub_type === eachMethod.sub_type) &&
        (!type || type === eachMethod.type)
    );
    if (methodIndex > -1) {
      logEmissionMethods[methodIndex].selected = e.target.checked;
      preferences[categoryIndex].isAdded = true;
      setCategoryPreferences([...categoryPreferences]);
    }
  };

  const checkMinus = (e: any) => {
    if (
      e.code === "ArrowDown" ||
      e?.code === "ArrowUp" ||
      e?.code === "Minus"
    ) {
      e.preventDefault();
    }
  };

  const onClickShowComments = (index: number) => {
    categoryData[index].showComments = !categoryData[index].showComments;
    setCategoryData([...categoryData]);
  };

  const onChangePreferenceComment = (event: any, categoryIndex: any) => {
    if (
      //event?.target?.value?.length &&
      categoryIndex >= 0 &&
      categoryData[categoryIndex]
    ) {
      const newComment = event.target.value || "";
      categoryData[categoryIndex].usageComments = newComment; //event.target.value || "";
      const categoryPreferencesIndex = categoryPreferences.findIndex(
        (eachPreference: any) =>
          eachPreference.category === categoryData[categoryIndex].id
      );
      if (categoryPreferencesIndex > -1) {
        categoryPreferences[categoryPreferencesIndex].usageComments =
          event.target.value || "";
      }
      setCategoryData([...categoryData]);
      setCategoryPreferences([...categoryPreferences]);
    }
  };

  const handleSwitchPreferenceUsage = (value: any, categoryIndex: any) => {
    if (categoryIndex >= 0 && categoryData[categoryIndex]) {
      const usageValue = value ? "fully" : "partially";
      categoryData[categoryIndex].usage = usageValue;
      const categoryPreferencesIndex = categoryPreferences.findIndex(
        (eachPreference: any) =>
          eachPreference.category === categoryData[categoryIndex].id
      );
      if (categoryPreferencesIndex > -1) {
        categoryPreferences[categoryPreferencesIndex].usage = usageValue;
      }
      setCategoryData([...categoryData]);
      setCategoryPreferences([...categoryPreferences]);
    }
  };

  useEffect(() => {
    getSettingPreferences(true)
      .then((res) => {
        const data = res.data.companyPreference.currency;
        setGwpVersion(res.data.companyPreference.gwp_version);
        setCurrency(data);
      })
      .catch((error) => console.log(error));
  }, []);
  const onChangeCurrency = (e: any) => {
    if (e) {
      setCurrency(e);
    }
  };
  useEffect(() => {
    getEmissionCurrencyService().then((res: any) => {
      setCurrencies([...res.data]);
    });
  }, []);
  // const onChangeCurrency =(e:any,eachPreference:any) => {
  //   eachPreference["currency"] = e;
  // }

  return (
    <Fragment>
      <div className="pw-bunit-preferences-main w-55v overflow-y-auto flex flex-col gap-10">
        <div className="flex flex-col gap-2 pt-10">
          <div className="text-xl text-neutral-600 font-bold">
            {t("Facility Preferences")}
          </div>
          <div className="text-sm text-neutral-700 pw-border-bottom pb-1">
            {t("Please provide necessary information below for this Facility")}
          </div>
        </div>
        <div className="pw-bunit-basic-card flex flex-col gap-8">
          <div className="pw-bunit-card-title font-bold">{t("BASIC")}</div>
          {/* <div className="flex flex-col gap-2">
            <div className="text-sm text-neutral-600">
              Region for Emission Factor Data
            </div>
            <div>

              <select
                name="country"
                value={country}
                className="pw-select"
                onChange={(e) => onChangeCountry(e)}
              >
                {countries.map((eachCountry: any, index: number) => (
                  <option key={eachCountry.id} value={eachCountry.id}>
                    {eachCountry.name}
                  </option>
                ))}
              </select>
            </div>
          </div> */}
          <div className="flex flex-col gap-1 items-start">
            <div className="text-sm text-neutral-600">
              {t("Scopes/Categories")}
            </div>
            <div className="flex flex-col w-full">
              {categoryData.map((eachCategory: any, index: number) => {
                return (
                  <div className="flex flex-col w-full">
                    {eachCategory.code === CATEGORY_CODE.CATEGORY_1_1 && (
                      <div className="text-slate-700 text-sm font-bold font-['Proxima Nova'] pt-3 pb-2">
                        Scope 1 : Direct emissions
                      </div>
                    )}
                    {eachCategory.code === CATEGORY_CODE.CATEGORY_2_1 && (
                      <div className="text-slate-700 text-sm font-bold font-['Proxima Nova'] pt-3 pb-2">
                        Scope 2 : Indirect emissions from purchased energy
                      </div>
                    )}
                    {eachCategory.code === CATEGORY_CODE.CATEGORY_3_1 && (
                      <div className="justify-start items-start gap-4 inline-flex pt-3 pb-2">
                        <div className="text-slate-700 text-sm font-bold font-['Proxima Nova']">
                          Scope 3 : Other indirect emissions
                        </div>
                        {!checkSubscriptionPermission(
                          "EMISSION_SCOPE_3",
                          plansPermissions
                        ) && <SubscriptionUpgrade />}
                      </div>
                    )}

                    <div
                      key={eachCategory.id}
                      className="flex flex-row items-start justify-between gap-1 w-full basicmain gap-8"
                      id={`basicmain-${eachCategory.id}`}
                    >
                      <Tooltip
                        title={`${
                          !eachCategory.factors_exists
                            ? "No emission sources found"
                            : ""
                        }`}
                        placement="topLeft"
                        arrow={false}
                      >
                        <div
                          className="flex flex-row items-start gap-1 w-9/12"
                          style={{ width: "65%" }}
                        >
                          <Checkbox
                            disabled={
                              !eachCategory.factors_exists ||
                              (eachCategory.id > 17 &&
                                !checkSubscriptionPermission(
                                  "EMISSION_SCOPE_3",
                                  plansPermissions
                                ))
                            }
                            checked={eachCategory.selected}
                            onChange={(e) =>
                              AddOrRemovePreferences(e, eachCategory.id, index)
                            }
                            className="!pl-0"
                          />
                          <p
                            className={`text-sm text-neutral-900 w-full mt-[6px]`}
                          >
                            {eachCategory.code} - {eachCategory.name}
                          </p>
                        </div>
                      </Tooltip>
                      <div
                        className="flex flex-row justify-between items-start w-3/12 gap-8 mt-[6px]"
                        style={{ width: "30%" }}
                      >
                        {eachCategory.selected ? (
                          <div
                            className="flex flex-row h-[24px] items-center justify-center text-sm gap-4"
                            style={{ width: "80%" }}
                          >
                            <p>Partially</p>
                            <Switch
                              style={{ color: "green" }}
                              checked={eachCategory.usage === "fully"}
                              onChange={(e) =>
                                handleSwitchPreferenceUsage(e, index)
                              }
                              size="small"
                            />
                            <p>Fully</p>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <div className="flex flex-row items-center">
                          <div
                            className={`w-[24px] h-[24px] p-[4px] cursor-pointer ${
                              eachCategory.showComments ? "bg-neutral-300" : ""
                            }`}
                            onClick={() => {
                              onClickShowComments(index);
                            }}
                          >
                            <img
                              src="assets/icons/comment-processing-outline.svg"
                              alt=" "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {eachCategory.showComments ? (
                      <div className="w-full bg-gray-50 mb-2 mt-2 ml-2">
                        <TextField
                          type="text"
                          variant="outlined"
                          placeholder={t("Add comment")}
                          size="small"
                          value={eachCategory.usageComments}
                          name="email"
                          onChange={(e) => onChangePreferenceComment(e, index)}
                          className="pw-width-100 pw-input-field pw-input-text pw-category-comments comments h-4"
                          sx={styles}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}

              {/* <div className="flex flex-row items-center gap-1">
                <Checkbox
                  checked={category === "2.1"}
                  onChange={() => setCategory("2.1")}
                  className="!pl-0"
                />
                <p className="text-sm text-neutral-900">
                  Category 2.1 - Indirect emission from imported electricity
                  consumed
                </p>
              </div> */}
            </div>
          </div>
          <div className="flex flex-row items-center gap-6">
            <div className="text-sm text-neutral-600">{t("Currency")} </div>
            <div className="flex flex-col gap-3 w-48">
              <AntSelect
                className="pw-currency-pref pw-currency-select"
                suffixIcon={
                  <CaretDownOutlined className="!pointer-events-none" />
                }
                showSearch
                placeholder="Select currency"
                value={currency}
                onChange={(e) => onChangeCurrency(e)}
                // onSearch={onSearch}
                filterOption={(input, option: any) => {
                  let currObj = currencies.find(
                    (opt: any) => opt.id === option.value
                  );
                  return (
                    currObj?.name
                      ?.toLowerCase()
                      ?.includes(input.toLowerCase()) ||
                    currObj?.symbol
                      ?.toLowerCase()
                      ?.includes(input.toLowerCase())
                  );
                }}
              >
                {currencies.map((eachCurrency: any) => (
                  <Option key={eachCurrency.id} value={eachCurrency.id}>
                    {eachCurrency.symbol}
                  </Option>
                ))}
              </AntSelect>
            </div>
            <div className="text-sm text-neutral-600 ml-8">
              {t("Carbon price per tCO2e")}{" "}
            </div>
            <div className="flex flex-col gap-3 w-48">
              <InputNumber
                onKeyDown={checkMinus}
                keyboard={false}
                controls={false}
                type="number"
                className="pw-width-100 pw-input-field"
                id="pw-target-carbon-price"
                placeholder="-"
                onChange={(e) => {
                  setCarbonPrice(e);
                }}
                value={carbonPrice}
              ></InputNumber>
            </div>
          </div>
          <div>
            <div>GWP Version</div>
            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              className="w-40"
              value={gwpVersion}
              onChange={(e) => handleGWPVersionChange(e)}
            >
              <Option value="ar4" key="ar4">
                AR4
              </Option>
              <Option value="ar5" key="ar5">
                AR5
              </Option>
              <Option value="ar6" key="ar6">
                AR6
              </Option>
            </AntSelect>
          </div>
          <div className="flex  flex-row items-center gap-3">
            <div className="text-sm text-neutral-900">
              Directly approve all the emissions created by users
            </div>
            <Switch
              disabled={
                !checkSubscriptionPermission(
                  "EMISSION_APPROVAL",
                  plansPermissions
                )
              }
              style={{ color: "green" }}
              checked={directEmissionApproval}
              onChange={(e) => handleSwitch(e)}
              size="small"
            />
            {!checkSubscriptionPermission(
              "EMISSION_APPROVAL",
              plansPermissions
            ) && <SubscriptionUpgrade />}
          </div>
        </div>
        {categoryPreferences.map((eachPreference: any, index: number) => {
          return (
            <>
              {eachPreference.selected ? (
                <div
                  key={eachPreference.category}
                  id={`emissionSource${eachPreference.category}`}
                  className="pw-bunit-preferences-category flex flex-col gap-8 bg-white "
                >
                  <div className="text-xs text-neutral-600 font-bold uppercase">
                    {eachPreference.name}
                  </div>
                  <div className="flex flex-col gap-2">
                    <div className="text-sm text-neutral-600">
                      {t("Emission Factor Source")}
                    </div>
                    <div className="pw-multi-dropdown pw-cascader-pref">
                      <PWCascader
                        optionsData={eachPreference.subTypes}
                        defaultArray={eachPreference?.emissionSources?.map(
                          (eachType: any) =>
                            eachType.subType
                              ? [eachType.type, eachType.subType]
                              : [eachType.type]
                        )}
                        defaultOptions={
                          eachPreference.subTypes?.length
                            ? eachPreference.subTypes
                            : getInitOptionsFromDefault(
                                eachPreference.emissionSources
                              )
                        }
                        onSelectCascade={(e: any) => {
                          onSelectEmissionSource(e, index);
                        }}
                        multiple={isMultiSources(eachPreference)}
                        setContent={(e: any) => {
                          setCategorySourceContent(
                            null,
                            eachPreference.category,
                            index
                          );
                        }}
                        // onSelectNode={(e: any) => {
                        //   onSelectEmissionSource(e, index);
                        // }}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-4">
                    <div className="text-neutral-600 text-sm">
                      {t("Log Emission against")} :
                    </div>
                    <div className="flex flex-col gap-3">
                      <div className="flex flex-col gap-3 text-sm pw-logsubtype">
                        {eachPreference?.methods?.length
                          ? groupMethodsByTypeSubType(
                              eachPreference?.methods
                            )?.map((eachType: any) => (
                              <div>
                                <div className="m-2 text-neutral-600">
                                  {eachType[1][0].typename ||
                                    eachType[1][0].type_name}
                                </div>
                                {eachType[1].map(
                                  (eachMethod: any, index1: number) => {
                                    return (
                                      <div className="flex flex-row items-center ml-2">
                                        <Checkbox
                                          checked={eachMethod.selected}
                                          className={`${eachPreference.name
                                            .split(" - ")[0]
                                            .replace(/ /g, "")
                                            .replace(/\./g, "-")}-${
                                            eachType[1][0].typename.replace(
                                              / |[\(\),]/g,
                                              ""
                                            ) ||
                                            eachType[1][0].type_name.replace(
                                              / |[\(\),]/g,
                                              ""
                                            )
                                          }-${eachMethod.name.replace(
                                            /( |\&)/g,
                                            ""
                                          )}`}
                                          onChange={(e) =>
                                            onSelectEmissionLogMethod(
                                              e,
                                              index,
                                              eachMethod.id,
                                              eachMethod.type,
                                              eachMethod.sub_type
                                            )
                                          }
                                        />
                                        <div>{eachMethod.name}</div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ))
                          : eachPreference?.methods?.map(
                              (eachMethod: any, index1: number) => {
                                return (
                                  <div className="flex flex-row items-center ">
                                    <Checkbox
                                      checked={eachMethod.selected}
                                      className={`${eachPreference.name
                                        .split(" - ")[0]
                                        .replace(/ /g, "")
                                        .replace(
                                          /\./g,
                                          "-"
                                        )}-${eachMethod.name.replace(
                                        /( |\&)/g,
                                        ""
                                      )}`}
                                      onChange={(e) =>
                                        onSelectEmissionLogMethod(
                                          e,
                                          index,
                                          eachMethod.id
                                        )
                                      }
                                    />
                                    <div>{eachMethod.name}</div>
                                  </div>
                                );
                              }
                            )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          );
        })}

        {/* <div className="pw-bunit-preferences-category flex flex-col gap-8">
          <div className="text-xs text-neutral-600 font-bold uppercase">
            Category 1.2 - Direct emission from mobile combustion
          </div>
          <div className="flex flex-col gap-2">
            <div className="text-sm text-neutral-600">
              Emission Factor Source
            </div>
            <div>
              <MultiLevelDropDown
                dropdownContent={dropdownContent}
                onSelectNode={(e: any) => {
                  console.log(e);
                }}
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="font-bold text-neutral-600 text-sm">
              Log Emission against
            </div>
            <div className="flex flex-col gap-3">
              <div className="flex flex-row items-center gap-3">
                <input
                  type="radio"
                  name="logemissiontype"
                  className="pw-radio-bunit"
                />
                <div className="text-sm text-neutral-900">
                  Distance travelled for individual Vehicle ID
                </div>
              </div>
              <div className="flex flex-row items-center gap-3">
                <input
                  type="radio"
                  name="logemissiontype"
                  className="pw-radio-bunit"
                />
                <div className="text-sm text-neutral-900">
                  Fuel consumed for individual Vehicle ID
                </div>
              </div>
              <div className="flex flex-row items-center gap-3">
                <input
                  type="radio"
                  name="logemissiontype"
                  className="pw-radio-bunit"
                />
                <div className="text-sm text-neutral-900">
                  Distance travelled by a Vehicle type
                </div>
              </div>
              <div className="flex flex-row items-center gap-3">
                <input
                  type="radio"
                  name="logemissiontype"
                  className="pw-radio-bunit"
                />
                <div className="text-sm text-neutral-900">
                  Fuel consumed by a Vehicle Type
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="text-sm text-neutral-600">Types of Vehicles</div>
            <div>
              <select
                name="Vehicle Type"
                className="pw-bunit-preferences-select"
              ></select>
            </div>
          </div>
          <div className="flex flex-col gap-1 items-start">
            <div className="text-sm text-neutral-600">
              UOM for distance travelled in Individual Vehicle
            </div>
            <div className="flex flex-row gap-20">
              <div className="flex flex-row items-center gap-0.25">
                <Checkbox
                  checked={distUnit === "Kms"}
                  onChange={() => {
                    setDistUnit("Kms");
                  }}
                  className="!pl-0"
                />
                <p className="text-sm text-neutral-900">Kms</p>
              </div>
              <div className="flex flex-row items-center gap-0.25">
                <Checkbox
                  checked={distUnit === "Mtrs"}
                  onChange={() => {
                    setDistUnit("Mtrs");
                  }}
                  className="!pl-0"
                />
                <p className="text-sm text-neutral-900">Mtrs</p>
              </div>
              <div className="flex flex-row items-center gap-0.25">
                <Checkbox
                  checked={distUnit === "Miles"}
                  onChange={() => {
                    setDistUnit("Miles");
                  }}
                  className="!pl-0"
                />
                <p className="text-sm text-neutral-900">Miles</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-1 items-start">
            <div className="text-sm text-neutral-600">Vehicles Owned By</div>
            <div className="flex flex-col ">
              <div className="flex flex-row items-center gap-1">
                <Checkbox
                  checked={vehicleOwner === "company"}
                  onChange={() => {
                    setVehicleOwner("company");
                  }}
                  className="!pl-0"
                />
                <p className="text-sm text-neutral-900">
                  Completely owned by company
                </p>
              </div>
              <div className="flex flex-row items-center gap-1">
                <Checkbox
                  checked={vehicleOwner === "thirdparty"}
                  onChange={() => {
                    setVehicleOwner("thirdparty");
                  }}
                  className="!pl-0"
                />
                <p className="text-sm text-neutral-900">
                  Completely owned by 3rd party vendor
                </p>
              </div>
              <div className="flex flex-row items-center gap-1">
                <Checkbox
                  checked={vehicleOwner === "lease"}
                  onChange={() => {
                    setVehicleOwner("lease");
                  }}
                  className="!pl-0"
                />
                <p className="text-sm text-neutral-900">
                  Leased from 3rd party Vendor
                </p>
              </div>
              <div className="flex flex-row items-center gap-1">
                <Checkbox
                  checked={vehicleOwner === "custom"}
                  onChange={() => {
                    setVehicleOwner("custom");
                  }}
                  className="!pl-0"
                />
                <p className="text-sm text-neutral-900">Custom</p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className="flex flex-row justify-end pw-bunit-preferences-footer w-full gap-6">
        <div
          className="pw-bunit-cancel-button"
          onClick={() => navigate("/organisation/facility")}
        >
          {t("Cancel")}
        </div>
        <div
          className="pw-bunit-back-button"
          onClick={() => setStep(STEPS.ADD_UNIT)}
        >
          {t("Back")}
        </div>
        <button
          className={`${
            isSaveEnable
              ? isLoading
                ? "text-black bg-neutral-300"
                : "cursor-pointer bg-primary"
              : "text-black bg-neutral-300"
          } pw-bunit-button-save pw-bunit-button-primary  text-white `}
          disabled={!isSaveEnable || isLoading}
          onClick={() => createOrUpdateBusinessUnit()}
        >
          {isLoading ? (
            <div className="flex flex-row gap-2 p-2">
              <span>{t("Saving up")}</span>
              <CircularProgress size={20} />
            </div>
          ) : (
            <span>{t("Save")}</span>
          )}
        </button>
      </div>
      {enableAllApproved && (
        <ConfirmApproveDialog
          fromBunitsPreference={true}
          warningType={`approved`}
          handleSwitchValue={handleSwitchValue}
          setWarningType={setEnableAllApproved}
        />
      )}
    </Fragment>
  );
};

export default BusinessUnitPreferences;
